import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import {ScrollPanel} from 'primereact/scrollpanel';

import servicioSucursal from '../servicios/ServicioSucursal';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioSeries from '../servicios/ServicioSerie';


export class Sucursal extends Component {
  constructor() {
    super();
    this.state = {
      sucursal: {},
      paginacion: { registrosPorPagina: 10, join: {'tcSerie':'alias_tcSerie'} },
      inicio: 0,
      modalSucursal: false,
      erroresSucursal: {},
      modalConfirmacion: false,
      series: []
    };
  }


  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  componentDidMount() {
    this.obtener_pagina();
    this.obtener_series();
  }

  cambiar_pagina = (event) => {
    let { paginacion } = this.state;

    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtener_pagina();
  }

  obtener_pagina() {
    let { paginacion } = this.state;
    servicioSucursal.paginacion(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

      this.setState({ paginacion: response.data.objeto });


    }).catch((error) => {
      if (error)
        return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
    });

  }

  obtener_series = () => {
    servicioSeries.obtener_series().then(response => {
      this.setState({ series: response.data.lista });
    })
  }

  nuevo_sucursal = () => {
    this.setState({ modalSucursal: true, sucursal: {} ,erroresSucursal:{}});
  }

  buscar_like = () => {
    let { sucursal, paginacion } = this.state;
    servicioSucursal.busqueda_like(sucursal).then(response => {
      if (response.data.lista.length === 0) {
        this.growl.show({ life: 1000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
        paginacion['datos'] = response.data.lista;
        this.setState({ paginacion });
      } else {
        this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
        paginacion['datos'] = response.data.lista;
        this.setState({ paginacion });
      }
    })
  }

  cerrar_modal_sucursal = () => {
    this.setState({ modalSucursal: false, sucursal: {},erroresSucursal:{} });
  }

  guardar_sucursal = () => {
    let { sucursal } = this.state;
    let erorres = this.validar_formulario(sucursal);
    this.setState({ erroresSucursal: erorres });
    if (!Object.keys(erorres).length) {
      servicioSucursal.guardar(sucursal).then(response => {
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        this.setState({ sucursal: {}, modalSucursal: false, erroresSucursal: {} });
        this.obtener_pagina();
      });
    }
  }

  validar_formulario = (sucursal) => {
    const erroresRequeridos = {};

    if (!sucursal.nombre) {
      erroresRequeridos.nombre = "El nombre es requerido";
    }
    if (!sucursal.domicilio) {
      erroresRequeridos.domicilio = "EL domicilio es requerido";
    }

    if (!sucursal.tcSerie) {
      erroresRequeridos.tcSerie = "La serie es requerida";
    }
    if(!sucursal.codigoPostal){
      erroresRequeridos.codigoPostal = "El codigo postal es requerido";
    }

    return erroresRequeridos;
  }

  templateSerie = (option) => {
    return (
      <div className="p-clearfix">
        <span >{option.nombre} - {option.descripcion}</span>
      </div>
    );
  }

  columna_serie = (rowData, column) => {
    if(column.rowData.tcSerie!=null){
      return <p>{column.rowData.tcSerie.nombre} - {column.rowData.tcSerie.descripcion}</p>;
    }
  }

  columna_editar = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
        tooltip="editar" onClick={(e) => this.pre_editar_sucursal(column.rowData)}>
      </Button>
    </div>;
  }

  columna_eliminar = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
        tooltip="eliminar" onClick={(e) => this.pre_eliminar(column.rowData)}>
      </Button>
    </div>;
  }

  pre_eliminar=(objeto)=>{
    this.setState({sucursal:objeto,modalConfirmacion:true});
}

  pre_editar_sucursal = (objeto) => {
    this.setState({ sucursal: objeto, modalSucursal: true });
  }

  eliminar_sucursal=()=>{
    let {sucursal}=this.state;
    servicioSucursal.eliminar(sucursal).then(response=>{
          this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
          if (response.data.error === false) {
            this.setState({ sucursal: {}, modalConfirmacion: false, erroresSucursal: {} });
            this.obtener_pagina();
          }
        })
  }

  cerrar_modal_confirmacion=()=>{
    this.setState({modalConfirmacion:false,sucursal: {}});
  }

  render() {
    let { sucursal, paginacion, inicio, erroresSucursal, series } = this.state;

    let dialogFooterSucursal = (
      <div>
        <Button icon="pi-md-check" onClick={this.guardar_sucursal} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_sucursal} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    let dialogFooterConfirmacion=(
      <div>
      <Button icon="pi-md-check" onClick={this.eliminar_sucursal} label="Si estoy seguro" className="teal-btn flat-btn" />
      <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion} label="No estoy seguro" className="p-button-danger flat-btn" />
    </div>
    )

    return (
      <div>
        <Growl ref={(el) => this.growl = el} />


        <div className="card card-w-title">
          <h1 style={{marginBottom:'30px'}}>Administración de Sucursal</h1>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <Button type="button" className="blue-grey-btn flat-btn" label="Nueva Sucursal" name="nuevo" value="Nuevo"
                tooltip="Nueva sucursal" onClick={this.nuevo_sucursal} >
              </Button>
            </div>
          </div>
        </div>

        <div className="card card-w-title">
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <div className="p-col-12" style={{fontWeight:'bold', marginLeft:'5px'}}>
                <label htmlFor="buscar">Buscar Sucursal:</label>
              </div>
              <div className="p-col-12 p-md-6" style={{marginLeft:'5px'}}>
                <InputText className="p-inputtext" placeholder="Escribe el nombre o domicilio de sucursal" name="sucursal.busquedaLike" value={sucursal.busquedaLike || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscar_like} />
              </div>
            </div>
          </div>
        </div>

        <div className="p-grid" style={{marginBottom:'50px'}}>
          <div className="p-col-12">
            <div className="card card-w-title">
              <DataTable value={paginacion.datos} responsive={true} header="MIS SUCURSALES">
                <Column field="nombre" header="Nombre" autoLayout={true} style={{textAlign:'center'}}/>
                <Column field="domicilio" header="Domicilio" autoLayout={true} style={{textAlign:'center'}}/>
                <Column body={this.columna_serie} header="Serie" autoLayout={true} style={{textAlign:'center'}}/>
                <Column header="Editar" body={this.columna_editar} style={{textAlign:'center'}}/>
                <Column header="Eliminar" body={this.columna_eliminar} style={{textAlign:'center'}}/>
              </DataTable>
              <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiar_pagina.bind(this)} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
            </div>
          </div>
        </div>

        <Dialog header="Sucursal, los campos con * son requeridos." visible={this.state.modalSucursal} modal={true} style={{ width: '60vw' }} footer={dialogFooterSucursal} onHide={this.cerrar_modal_sucursal}>
        <ScrollPanel style={{width: '100%', height: '300px'}}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-2">
              <label htmlFor="nombre">* Nombre:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText name="sucursal.nombre" value={sucursal.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresSucursal.nombre ? 'p-error' : ''} />
              {erroresSucursal.nombre ? <div> <Message severity="error" text={erroresSucursal.nombre} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="domicilio">* Domicilio:</label>
            </div>
            <div className="p-col-12 p-md-4">
              <InputText name="sucursal.domicilio" value={sucursal.domicilio || ''} onChange={this.asignarValoresObjeto} className={erroresSucursal.domicilio ? 'p-error' : ''} />
              {erroresSucursal.domicilio ? <div> <Message severity="error" text={erroresSucursal.domicilio} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="tcSerie">* Serie:</label>
            </div>
            <div className="p-col-12 p-md-10">
              <Dropdown dataKey="id" name="sucursal.tcSerie" itemTemplate={this.templateSerie} options={series} value={sucursal.tcSerie  || ''} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="nombre" className={erroresSucursal.tcSerie ? 'p-error' : ''} />
              {erroresSucursal.tcSerie ? <div> <Message severity="error" text={erroresSucursal.tcSerie} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-2">
              <label htmlFor="codigoPostal">* Codigo Postal:</label>
            </div>
            <div className="p-col-12 p-md-10">
            <InputText name="sucursal.codigoPostal" value={sucursal.codigoPostal || ''} onChange={this.asignarValoresObjeto} className={erroresSucursal.codigoPostal ? 'p-error' : ''} />
              {erroresSucursal.codigoPostal ? <div> <Message severity="error" text={erroresSucursal.codigoPostal} /> </div> : null}
            </div>
          </div>
          </ScrollPanel>
        </Dialog>

        <Dialog header="Confirmación" visible={this.state.modalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacion} onHide={this.cerrar_modal_confirmacion}>
        <h2>¿Estás seguro de eliminar el Sucursal ?</h2>
      </Dialog>


      </div>

    );

  }

}